<template>
	<div class="jconfig">
		<div class="btnbox">
			<el-button type="primary" size="small" @click="onadd()">渠道配置</el-button>
		</div>
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0"
					v-if="filtershow">
					<el-form-item label="" prop="shop_id">
						<el-select v-model="formfilter.shop_id" placeholder="请选择渠道">
							<el-option label="渠道" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in qudao" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column prop="shop_name"  fixed="left" label="渠道" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="oshop" label="聚水潭店铺(订单)" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="ostore" label="聚水潭仓库(订单)" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="sstore" label="聚水潭仓库(库存)" align="center" header-align="center">
					</el-table-column>
					<el-table-column label="库存推送比率" align="center" header-align="center">
						<template slot-scope="scope">
							<div v-if="scope.row.stock_rate">{{scope.row.stock_rate}}%</div>
						</template>
					</el-table-column>
					<el-table-column label="SKU解析规则" align="center" header-align="center">
						<template slot-scope="scope">
							<div v-if="scope.row.sku_parse_rule">{{ruleMap[scope.row.sku_parse_rule]}}</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center" header-align="center" width="100px">
						<template slot-scope="scope">
							<div class="operation_i">
								<span @click="onupdate(scope.row)">编辑</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="pagediv">
				<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50]"
					:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
					@current-change="handleCurrentChange" @size-change="handleSizeChange">
				</el-pagination>
			</div>
		</div>

		<el-dialog title="渠道配置" :visible.sync="show" width="600px" :before-close="onclose">
			<div class="forms" v-if="show">
				<el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px">
					<el-form-item label="渠道" prop="shop_id" class="item">
						<el-select v-model="ruleForm.shop_id" placeholder="请选择渠道">
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in qudao" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<div class="ohead">库存</div>
					<el-form-item label="聚水潭仓库" prop="stock_jst_store_id" class="item">
						<div @click="onck(2)">
							<el-input v-model="ruleForm.sstore" placeholder="请选择聚水潭仓库" :readonly="true"></el-input>
						</div>
						<div class="field-tip">库存同步时，从哪个仓库拉取库存数据</div>
					</el-form-item>
					<el-form-item label="SKU解析规则" prop="sku_parse_rule" class="item">
						<el-select v-model="ruleForm.sku_parse_rule" placeholder="请选择SKU解析规则">
							<el-option :label="v.label" :value="v.value" v-for="(v,k) in skuParseRuleOptions" :key="k">
							</el-option>
						</el-select>
						<div class="field-tip">商品编号与款号尺码的拆分规则</div>
					</el-form-item>
					<el-form-item label="推送比率" prop="stock_rate" class="item1">
						<el-input v-model.number="ruleForm.stock_rate" type="number" placeholder="请设置推送比率">
							<template slot="append">%</template>
						</el-input>
					</el-form-item>
					<div class="ohead">订单</div>
					<el-form-item label="聚水潭店铺" prop="order_jst_shop_id" class="item">
						<div @click="ondp">
							<el-input v-model="ruleForm.oshop" placeholder="请选择聚水潭店铺" :readonly="true"></el-input>
						</div>
						<div class="field-tip">订单推送到聚水潭时，标记该订单属于哪个店铺（销售来源）</div>
					</el-form-item>
					<el-form-item label="聚水潭仓库" prop="order_jst_store_id" class="item">
						<div @click="onck(1)">
							<el-input v-model="ruleForm.ostore" placeholder="请选择聚水潭仓库" :readonly="true"></el-input>
						</div>
						<div class="field-tip">订单推送到聚水潭时，指定由哪个仓库发货（履约方）</div>
					</el-form-item>
					<div class="ohead">售后</div>
					<el-form-item label="售后功能" prop="aftersale_enabled" class="item">
						<el-switch v-model="ruleForm.aftersale_enabled" :active-value="1" :inactive-value="0" active-text="开启" inactive-text="关闭"></el-switch>
						<div class="field-tip">开启后，售后单将同步到聚水潭</div>
					</el-form-item>
					<el-form-item label="售后仓库" prop="aftersale_jst_store_id" class="item" v-show="ruleForm.aftersale_enabled">
						<div @click="onck(3)">
							<el-input v-model="ruleForm.astore" placeholder="请选择售后仓库" :readonly="true"></el-input>
						</div>
						<div class="field-tip">售后退货时，指定退货到的聚水潭仓库（与订单/库存仓库共用数据源）</div>
					</el-form-item>
				</el-form>
				<div class="myjg" v-if="ruleForm.id">更改绑定原渠道库存将清空现有库存，谨慎操作</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose">取消</el-button>
				<el-button type="primary" @click="onsub()">确定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="聚水潭店铺" :visible.sync="dpshow" width="600px" :before-close="onclose1">
			<div class="table">
				<el-table :data="dplist" style="width: 100%;margin-bottom: 20px;" border height="250px">
					<el-table-column label="" align="center" header-align="center" width="36px">
						<template slot-scope="scope">
							<el-radio v-model="selectedId" :label="scope.row.shop_id"
								@change="handleRadioChange(scope.row,1)">&nbsp;</el-radio>
						</template>
					</el-table-column>
					<el-table-column prop="shop_id" label="店铺编号" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="shop_name" label="店铺名称" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="co_id" label="公司编号" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="short_name" label="店铺简称" align="center" header-align="center">
					</el-table-column>
				</el-table>
			</div>
			<div v-if="selectedName" style="margin-bottom: 10px;">已选择:{{selectedId}} {{selectedName}}</div>
			<div>
				<el-button-group>
					<el-button type="primary" icon="el-icon-arrow-left" v-if="page1>1" size="small" @click="onpage(0)">上一页</el-button>
					<el-button type="primary" v-if="has_next" size="small" @click="onpage(1)">下一页<i class="el-icon-arrow-right el-icon--right"></i></el-button>
				</el-button-group>
			</div>
			
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose1">取消</el-button>
				<el-button type="primary" @click="ondpsub()">确定</el-button>
			</div>
		</el-dialog>
		
		<el-dialog title="聚水潭仓库" :visible.sync="ckshow" width="600px" :before-close="onclose2">
			<div class="table">
				<el-table :data="cklist" style="width: 100%;margin-bottom: 20px;" border height="250px">
					<el-table-column label="" align="center" header-align="center" width="36px">
						<template slot-scope="scope">
							<el-radio v-model="selectedId" :label="scope.row.wms_co_id" @change="handleRadioChange(scope.row,2)">&nbsp;</el-radio>
						</template>
					</el-table-column>
					<el-table-column prop="wms_co_id" label="分仓编号" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="name" label="分仓名称" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="co_id" label="公司编号" align="center" header-align="center">
					</el-table-column>
				</el-table>
			</div>
			<div v-if="selectedName" style="margin-bottom: 10px;">已选择:{{selectedId}} {{selectedName}}</div>
			<div>
				<el-button-group>
					<el-button type="primary" icon="el-icon-arrow-left" v-if="page1>1" size="small" @click="onpage1(0)">上一页</el-button>
					<el-button type="primary" v-if="has_next" size="small" @click="onpage1(1)">下一页<i class="el-icon-arrow-right el-icon--right"></i></el-button>
				</el-button-group>
			</div>
			
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose2">取消</el-button>
				<el-button type="primary" @click="oncksub()">确定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	export default {
		name: 'jconfig',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,

				page1: 1,
				total1: 0,

				filtershow: true,
				formfilter: {
					shop_id: ""
				},
				qudao: [],
				show: false,
				ruleForm: {
					id: "",
					shop_id: "",
					order_jst_shop_id: "",
					order_jst_store_id: "",
					stock_jst_store_id: "",
					stock_rate: 0,
					sku_parse_rule: 1,
					oshop: "",
					ostore: "",
					sstore: "",
					aftersale_enabled: 1,
					aftersale_jst_store_id: "",
					astore: "",
				},

				skuParseRuleOptions: [
					{ label: '|竖杠，示例：AWDT871-1|XL', value: 1 },
					{ label: '/反斜杠，示例：AWDT871-1/XL', value: 2 },
					{ label: '-减号，示例：AWDT871-1-XL', value: 3 },
					{ label: '无，示例：AWDT871-1XL', value: 4 }
				],
				ruleMap: { 1: '|竖杠，示例：AWDT871-1|XL', 2: '/反斜杠，示例：AWDT871-1/XL', 3: '-减号，示例：AWDT871-1-XL', 4: '无，示例：AWDT871-1XL' },
				rules: {
					shop_id: [{
						required: true,
						message: '请选择渠道',
						trigger: 'change'
					}],
					
					order_jst_shop_id: [{
						required: true,
						message: '请选择聚水潭店铺',
						trigger: 'change'
					}],
					
					order_jst_store_id: [{
						required: true,
						message: '请选择聚水潭仓库',
						trigger: 'change'
					}],
					
					stock_jst_store_id: [{
						required: true,
						message: '请选择聚水潭仓库',
						trigger: 'change'
					}],
					
					stock_rate: [{
						required: true,
						message: '请输入推送比率',
						trigger: 'blur'
					}],
					
					aftersale_jst_store_id: [{
						required: true,
						message: '请选择售后仓库',
						trigger: 'change'
					}]
				},
				dpshow: false,
				dplist: [],
				selectedId: "",
				selectedName: "",
				has_next: false,
				ckshow: false,
				cklist: [],
				cktype: 0,
				
				sishuju:{
					order_jst_shop_id: "10414157",
					order_jst_store_id: "12958680",
					stock_jst_store_id: "12958680",
					oshop: "zdydlihh",
					ostore: "zdydlihh2",
					sstore: "zdydlihh2",
				}
			}
		},

		mounted() {
			this.onlist();
			this.onqudao();
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height) + 30;
					this.$refs.tablediv.style.height = "calc(100% - " + num + "px)";
				}
			});
			this.resizeObserver.observe(this.$refs.filter);
		},

		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},

		methods: {
			handleCurrentChange() {
				this.onlist();
			},

			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onlist();
			},

			onfilter() {
				this.page = 1;
				this.onlist();
			},

			onreset() {
				this.formfilter = {
					shop_id: ""
				};
				this.page = 1;
				this.onlist();
			},

			onlist() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.page = this.page;
				obj.limit = this.pageSize;

				this.$axios.post('api/jst/config_list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onqudao() {
				var obj = {
					code: "",
					name: "",
					state: 2,
					page: 1,
					limit: 99999
				};

				this.$axios.post('api/user/shop_list', obj).then(res => {
					if (res.data.code == 0) {
						this.qudao = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onadd() {
				this.show = true;
			},

			onclose() {
				this.show = false;
				this.ruleForm = {
					id: "",
					shop_id: "",
					order_jst_shop_id: "",
					order_jst_store_id: "",
					stock_jst_store_id: "",
					stock_rate: 0,
					sku_parse_rule: 1,
					oshop: "",
					ostore: "",
					sstore: "",
					aftersale_enabled: 1,
					aftersale_jst_store_id: "",
					astore: "",
				};
			},
			
			onsub() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						var obj = JSON.parse(JSON.stringify(this.ruleForm));
						//死数据，开发用
						// console.log('现在提交的是死数据，联系前端删除');
						// obj.order_jst_shop_id = this.sishuju.order_jst_shop_id;
						// obj.order_jst_store_id = this.sishuju.order_jst_store_id;
						// obj.stock_jst_store_id = this.sishuju.stock_jst_store_id;
						// obj.oshop = this.sishuju.oshop;
						// obj.ostore = this.sishuju.ostore;
						// obj.sstore = this.sishuju.sstore;
						//到此删除掉
						this.$axios.post('api/jst/config_save', obj).then(res => {
							if (res.data.code == 0) {
								this.$message.success('操作成功');
								this.onclose();
								this.onlist();
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
				
			},

			ondp() {
				this.selectedId = JSON.parse(JSON.stringify(this.ruleForm.order_jst_shop_id));
				this.selectedName =	JSON.parse(JSON.stringify(this.ruleForm.oshop));
				this.onshop();
			},
			
			onpage(n) {
				if(n == 0) {
					this.page1 = this.page1-1;
				} else {
					this.page1 = this.page1+1;
				}
				this.onshop();
			},

			onshop() {
				var obj = {
					shop_ids: "",
				};
				obj.page = this.page1;
				this.$axios.post('api/jst/shop_list', obj).then(res => {
					if (res.data.code == 0) {
						this.dpshow = true;
						this.total1 = res.data.data.count;
						this.dplist = res.data.data[1].data.datas;
						this.has_next = res.data.data[1].data.has_next;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onclose1() {
				this.dpshow = false;
				this.dplist = [];
				this.selectedId = "";
				this.selectedName = "";
				this.page1 = 1;
				this.total1 = 0;
				this.has_next = false;
			},
			
			ondpsub() {
				this.ruleForm.order_jst_shop_id = JSON.parse(JSON.stringify(this.selectedId));
				this.ruleForm.oshop = JSON.parse(JSON.stringify(this.selectedName));
				this.onclose1();
			},

			handleRadioChange(val,n) {
				if(n == 1) {
					this.selectedName = val.shop_name;
				}
				
				if(n == 2) {
					this.selectedName = val.name;
				}
			},
			
			onck(n) {
				this.cktype = n;
				if(n == 1) {
					this.selectedId = JSON.parse(JSON.stringify(this.ruleForm.order_jst_store_id));
					this.selectedName =	JSON.parse(JSON.stringify(this.ruleForm.ostore));
				}
				if(n == 2) {
					this.selectedId = JSON.parse(JSON.stringify(this.ruleForm.stock_jst_store_id));
					this.selectedName =	JSON.parse(JSON.stringify(this.ruleForm.sstore));
				}
				if(n == 3) {
					this.selectedId = JSON.parse(JSON.stringify(this.ruleForm.aftersale_jst_store_id));
					this.selectedName =	JSON.parse(JSON.stringify(this.ruleForm.astore));
				}
				this.onpartner();
			},
			
			onpartner() {
				var obj = {};
				obj.page = this.page1;
				this.$axios.post('api/jst/partner_list', obj).then(res => {
					if (res.data.code == 0) {
						this.ckshow = true;
						this.total1 = res.data.data.count;
						this.cklist = res.data.data[1].data.datas;
						this.has_next = res.data.data[1].data.has_next;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			onclose2() {
				this.ckshow = false;
				this.cklist = [];
				this.cktype = 0;
				this.selectedId = "";
				this.selectedName = "";
				this.page1 = 1;
				this.total1 = 0;
				this.has_next = false;
			},
			
			onpage1(n) {
				if(n == 0) {
					this.page1 = this.page1-1;
				} else {
					this.page1 = this.page1+1;
				}
				this.onpartner();
			},
			
			oncksub() {
				if(this.cktype == 1) {
					this.ruleForm.order_jst_store_id = JSON.parse(JSON.stringify(this.selectedId));
					this.ruleForm.ostore = JSON.parse(JSON.stringify(this.selectedName));
				}
				
				if(this.cktype == 2) {
					this.ruleForm.stock_jst_store_id = JSON.parse(JSON.stringify(this.selectedId));
					this.ruleForm.sstore = JSON.parse(JSON.stringify(this.selectedName));
				}
				
				if(this.cktype == 3) {
					this.ruleForm.aftersale_jst_store_id = JSON.parse(JSON.stringify(this.selectedId));
					this.ruleForm.astore = JSON.parse(JSON.stringify(this.selectedName));
				}
				
				this.onclose2();
			},
			
			onupdate(data) {
				for (let key in this.ruleForm) {
					this.ruleForm[key] = data[key];
				}
				if (!this.ruleForm.sku_parse_rule) {
					this.ruleForm.sku_parse_rule = 1;
				}
				this.show = true;
			}
		}
	}
</script>

<style scoped lang="less">
	.jconfig {
		height: 100%;
	}

	.tablebox {
		height: calc(100% - 104px);
	}

	.tablediv {
		height: 100%;
	}

	/deep/.forms .el-select {
		width: 400px;
	}

	.ohead {
		width: 100%;
		height: 40px;
		font-size: 14px;
		font-weight: bold;
		color: #000;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #EBEEF5;
		margin-bottom: 12px;

		span {
			color: #ff4714;
			margin-left: 6px;
		}
	}
	
	.item {
		/deep/ .el-input {
			width: 250px !important;
		}
		
		/deep/ .el-select {
			width: 250px !important;
		}
	}
	
	.item1 {
		/deep/ .el-input {
			width: 150px !important;
		}
	}

	.field-tip {
		line-height: 1.4;
		font-size: 12px;
		color: #909399;
		margin-top: 4px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jushuitan/config.vue